/**
 * Product Tech Notes — Torque King 4x4
 * Loads tech notes from static JSON and renders on product pages.
 * Shows generic notes always + component-specific notes when YMM context is in URL.
 * URL params: ?ymm_ctx=Make|CompType|CompName (set by YMM search page links)
 */
(function () {
  'use strict';

  function init() {
    const container = document.querySelector('[data-tech-notes]');
    if (!container) return;

    const jsonUrl = container.dataset.techNotesUrl;
    if (!jsonUrl) return;

    const params = new URLSearchParams(window.location.search);
    const ymmCtx = params.get('ymm_ctx') || '';

    fetch(jsonUrl)
      .then(r => r.json())
      .then(data => render(container, data, ymmCtx))
      .catch(err => {
        console.warn('[TechNotes] Failed to load:', err);
        container.style.display = 'none';
      });
  }

  function render(container, data, ymmCtx) {
    const allNotes = data.notes || {};
    const genericIds = data.generic || [];
    const componentNotes = data.component_notes || {};

    // Collect note IDs to show
    const noteIds = new Set();

    // Always show generic notes
    genericIds.forEach(id => noteIds.add(String(id)));

    // Add component-specific notes if context provided
    if (ymmCtx && componentNotes[ymmCtx]) {
      componentNotes[ymmCtx].forEach(id => noteIds.add(String(id)));
    }

    if (noteIds.size === 0) {
      container.style.display = 'none';
      return;
    }

    // Sort by sort_order from the note data
    const notes = [...noteIds]
      .map(id => allNotes[id])
      .filter(Boolean)
      .sort((a, b) => (a.o || 0) - (b.o || 0));

    if (notes.length === 0) {
      container.style.display = 'none';
      return;
    }

    // Build accordion HTML
    let html = '';
    notes.forEach((note, i) => {
      const title = note.t || 'Tech Note';
      const body = note.b || '';
      const isOpen = i === 0 ? ' open' : '';

      html += `
        <details class="tech-note__item"${isOpen}>
          <summary class="tech-note__summary">
            <span class="tech-note__icon">⚙</span>
            <span class="tech-note__title">${escapeHtml(title.replace(/^\d+-/, ''))}</span>
            <svg class="tech-note__chevron" width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path d="M1 1.5l5 5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </summary>
          <div class="tech-note__body prose">${body}</div>
        </details>
      `;
    });

    const heading = container.dataset.heading || 'Tech Notes';
    container.innerHTML = `
      <div class="tech-notes__header">
        <h3 class="tech-notes__heading">${escapeHtml(heading)}</h3>
        <span class="tech-notes__count">${notes.length} note${notes.length !== 1 ? 's' : ''}</span>
      </div>
      <div class="tech-notes__list">${html}</div>
    `;
    container.style.display = '';
  }

  function escapeHtml(str) {
    const d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
